import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Main/home';
import Details from './components/Detail/Details';
import Main from './components/DetailPerso/Main';
import Center from './components/Progres/Center';
import Milieu from './components/EtapTrois/Milieu';
import Middle from './components/Etapquatre/Middle.jsx'
import Collections from './components/Etapquatre/SousEtap/Collections';
import Gather from './components/EtapQuatreJ/Gather';
import Groupe from './components/EtapQuatrej1/Groupe';
import Rassemble from './components/EtapQuatrej2/Rassemble';
import Principal from './components/EtapQuatreJ3/Principal';
import CopyMain from './components/EtapQuatreJ4/CopyMain';
import Ras from './components/EtapQuatrej5/Ras';
import Sommet from './components/EtapQuatreJ6/Sommet';
import JS from './components/reserve/js.jsx'
import Range from './components/EtapCinq/Range.jsx';
import News from './components/EtapQuatreJ7/News.jsx'
import Login from './features/auth/Login.js';
import Signup from './features/auth/Signup.js';


function App() {
  return (
    <Router>      
      <Routes>
        <Route path="/" element={<Home />} />  
        <Route path='/login' element={<Login/>} /> 
        <Route path="/Details" element={<Details/>}  />   
        <Route path="/Main" element={<Main/>} />  
        <Route path='/Center' element={<Center/>} />     
        <Route path='/Milieu' element={<Milieu/>} />     
        <Route path='/Middle' element={<Middle/>} />
        <Route path='/Collections' element={<Collections/>} />
        <Route path='/Gather' element={<Gather/>} />
        <Route path='/Groupe' element={<Groupe/>} />
        <Route path='/Rassemble' element={<Rassemble/>} />
        <Route path='/Principal' element={<Principal/>} />
        <Route path='/CopyMain' element={<CopyMain/>} />
        <Route path='/Ras' element={<Ras/>} />
        <Route path='/Sommet' element={<Sommet/>} />
        <Route path='/js' element={<JS/>} />
        <Route path='/Range' element={<Range/>} />
        <Route path='/News' element={<News/>} />
        <Route path='/signup' element={<Signup/>} />
      </Routes>
    </Router>
  );
}

export default App;
